import {Text} from "@mantine/core";
import {PropsWithChildren} from 'react'

export function PageTitleText(props: PropsWithChildren) {
    return (
        <Text size="2rem" fw={600}>
            {props.children}
        </Text>
    );
}